export default __webpack_public_path__ + "static/media/nuxtjs.fe96e54e.svg";